import * as Sentry from '@sentry/nextjs'
export const sentrySetContext: typeof Sentry.setContext = Sentry.setContext
